import React from 'react';

import Dropzone from 'react-dropzone';

import { DropZoneContent } from '../DropZoneContent';

import type { DropZoneAreaPresentationProperties } from './DropZoneAreaView.types';

export const DropZoneAreaView: React.FC<DropZoneAreaPresentationProperties> = ({
  dataTest = 'dropzone_area_view',
  dropzoneProps,
  accept,
  handleDropAccepted,
  handleDropRejected,
  maxFileSize,
  maxFileSizeFormatted,
  isMultiple,
  filesLimit,
  dropzoneText,
  icon,
  inputProps,
  dropZoneStyles,
  dropzoneParagraphStyles,
  acceptedFormatsText,
}) => (
  <Dropzone
    {...dropzoneProps}
    accept={accept}
    onDropAccepted={handleDropAccepted}
    onDropRejected={handleDropRejected}
    maxSize={maxFileSize}
    multiple={isMultiple}
    maxFiles={filesLimit}
  >
    {properties => (
      <DropZoneContent
        {...properties}
        dataTest={dataTest}
        dropzoneText={dropzoneText}
        icon={icon}
        inputProps={inputProps}
        dropZoneStyles={dropZoneStyles}
        dropzoneParagraphStyles={dropzoneParagraphStyles}
        maxFileSizeFormatted={maxFileSizeFormatted}
        acceptedFormatsText={acceptedFormatsText}
      />
    )}
  </Dropzone>
);
